export const getPlatform = (): string =>
  (navigator as any).userAgentData?.platform ||
  navigator?.platform ||
  'unknown';

export const isMac = () => {
  return /MAC/.test(getPlatform().toUpperCase());
};

export const MODIFIER_SYMBOL = isMac() ? '⌘' : 'Ctrl';
